import type { RetrieveMaskingEmailResponse } from '@/types/domains/UserType';
import type { RouteLocationNormalized } from 'vue-router';

// パスワード再設定ミドルウェア
// パスワード再設定用トークンが無効であれば、パスワードお忘れの方画面を表示する
export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
  const token = to.params.token;
  try {
    const data: RetrieveMaskingEmailResponse = await useAuth().retrieveMaskingEmail(token);
    to.meta.maskingEmail = data.value.maskingEmail;
  } catch (error) {
    return await navigateTo({ path: '/password/reset', query: { error: 'true' } });
  }
});
